import React, { useEffect } from "react";
import { Container, Box } from '@mui/material';
// import Link from 'next/link';
import { useRouter } from 'next/router';
import { dataConstants } from '../../src/constants';
// import { styled } from '@mui/material/styles';
import FundSummary from '../../src/components/Funds/Summary';
import { withProtected } from '../../src/hook/route';
import chart from '../../src/api/decorators/chart/chart';
import getFundInfo from "../../lib/fund/_getFundInfo";
import getFundTabs from '../../lib/fund/_getFundTabs';
import getPageMetaTags from '../../lib/meta/_getMetaTags';
import getChartTheme from '../../lib/charts/_getThemes';
import getFundNews from "../../lib/fund/_getFundNews";
import getPageInfo from "../../lib/fund/_getPageInfo";
import getStockIdeas from "../../lib/stock-ideas/_getStockIdeas";
import matter from "gray-matter";
import { sortByDate } from "../../src/utils/helpers";
import getFundMetrics from "../../lib/fund/_getFundMetrics";
import getStockTabs from "../../lib/stock/_getStockTabsData";
// import onPageInit from "../../src/actions/onPageInit";

const baseValue = {};

const settings = (baseline = baseValue, payload = {}) => ({
  ...baseline,
  ...payload,
});


const getTheme = (baseline = baseValue, payload = {}) => {
  const { type, chart_settings, series_settings = {}, icon } = payload || {};

  const { pallete, gradient } = payload.pallete ? JSON.parse(payload.pallete) : {};

  return {
    type,
    chartSettings: settings(undefined, JSON.parse(chart_settings)),
    pallete,
    gradient,
    seriesSettings: JSON.parse(series_settings),
    icon,
  };
};

const fundTabs = payload => {
  const { getFundTabs } = payload || {};
  const getTabData = d => {
    switch (d.type) {
      case dataConstants.STOCK_SECTION_TYPES.CHART:
        return d.tabData && d.tabData.length > 0 ? chart(undefined, d.tabData[0]).getChart : undefined;
      case dataConstants.STOCK_SECTION_TYPES.TICKER_TABLE:
        return d.tabData && d.tabData.length > 0 ? convertTickerTblFromData({ ...d.tabData[0], tickers: d.tabData[0].tickers ? JSON.parse(d.tabData[0].tickers) : d.tabData[0].tickers }) : undefined;
      case dataConstants.STOCK_SECTION_TYPES.TABLE_DATA:
        const tabData = d.tabData && d.tabData.length > 0 ? convertTblFromData(d.tabData) : undefined;
        return tabData;
      default:
        return d.tabData;
    }
  }

  return {
    getFundTabs: getFundTabs && getFundTabs.length && getFundTabs.map(d => ({
      ...d,
      tabData: getTabData(d),
      settings: d.settings ? JSON.parse(d.settings) : d.settings,
    })),
  };
}

const FCIK = ({
  fund_info, fund_tabs, chart_theme, toggleColorMode, themeMode, fund_news,
  isPremium, openDialog, page_info, fund_metrics, posts, pageLoading, stockideas_ads_settings,
  heatmapSettings,
}) => {
  const { asPath } = useRouter();
  const fcik = asPath && asPath.match(/\d/g)?.join("");
  const { getFundInfo } = fund_info || {};
  const { getFundTabs } = fundTabs(fund_tabs) || {};
  const { getNewsfeed } = fund_news || {}
  const { getThemes } = chart_theme || {};
  const [themes, setThemes] = React.useState(getThemes && getThemes.map(d => getTheme(undefined, d)))
  const [clipboard, setClipboard] = React.useState(null);
  // const [mounted, setMounted] = React.useState(false)

  // if (!mounted) {
  //   onPageInit(`funds/${fcik}`);
  // }

  // useEffect(() => {
  //   setMounted(true)
  // }, [])

  const handleClipboard = (value) => {
    const el = document.createElement('textarea');
    el.value = value;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    setClipboard("Copied");

    setTimeout(() => {
      setClipboard(null);
    }, 3000);
  };

  return (
    // <Container maxWidth="xl">
    <Box component="div" className="fund-detail-wrapper" >
      <FundSummary
        show={true}
        info={getFundTabs}
        data={getFundTabs}
        // getTableCell={cell => <Cell cell={cell} doAppAction={this.props.doAppAction} />}
        cik={fcik}
        name={getFundInfo && getFundInfo.length ? getFundInfo[0].name : ''}
        themeMode={themeMode}
        themes={themes}
        fundNews={getNewsfeed}
        handleClipboard={handleClipboard}
        clipboard={clipboard}
        asPath={asPath}
        isPremium={isPremium}
        openDialog={openDialog}
        page_info={page_info}
        fund_metrics={fund_metrics}
        posts={posts}
        positionBottom={true}
        pageLoading={pageLoading}
        ad_settings={stockideas_ads_settings}
        heatmapSettings={heatmapSettings}
      // plotData={plotData}
      // doChartAction={this.props.doChartAction}
      // doAppAction={this.props.doAppAction}
      // themes={themes}
      />
    </Box>
    // </Container>
  );
}

export async function getStaticPaths() {
  // const tabs = (await getHomeTabs()) || []
  // const recentHolding = tabs && tabs.length > 0 ? tabs.find(d => d.section_code === dataConstants.HOME_SECTIONS.RECENT_FUND_HOLDING) : undefined;
  // const recentHoldingTbl = recentHolding && recentHolding.tabData ? recentHolding.tabData : undefined;

  // Get the paths we want to pre-render based on posts
  // const paths = [0].map((fund) => ({
  //   // params: { fcik: fund.dv ? fund.dv.match(/\d/g).join("") : null },
  //   params: { fcik: '1067983' },
  //   // params: { fcik: '921669' },
  // }))

  const funds_jsonData = require('../../public/assets/search/funds.json');
  const paths = funds_jsonData.slice(0, dataConstants.HUNDRED_FUNDS).map(fund => ({
    params: { fcik: '' + fund.f },
  }))

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return {
    // paths: [{ params: { fcik: '1067983' } }, { params: { fcik: '921669' } }],
    paths,
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params, tabCode = "SUM", pagetype = "FUNDS", preview = false, type = "fund", limit = 16 }) {

  const funds_data = require('../../public/assets/search/funds.json');
  const fund = funds_data ? funds_data.find(d => d.f == params.fcik) : ""
  const fund_info = (await getFundInfo(params.fcik, preview)) || [];
  const { getFundMetrics: fund_metrics } = (await getFundMetrics(params.fcik, preview)) || [];
  const { getPageInfo: page_info } = (await getPageInfo(params.fcik, pagetype, preview)) || {};
  const fund_tabs = (await getFundTabs(params.fcik, tabCode, preview)) || [];
  const { getStockTabs: _Ads } = (await getStockTabs("AAPL", "ADS", preview)) || []; //"stock_ideas_reports"
  let stock_ideas_ads = _Ads && _Ads?.length > 0 ? _Ads?.find(d => d?.section_code === "stock_ideas_reports") : {}
  stock_ideas_ads = stock_ideas_ads && stock_ideas_ads?.settings ? stock_ideas_ads?.settings : ""

  // const fund_news = (await getFundNews(fund?.n?.replace(/(the| limited| ltd| company| co|[^A-Za-z0-9])/g, " ").trim().split(' ').slice(0, 3).join(' '), type, limit)) || []
  const fund_news = []
  const chart_theme = (await getChartTheme({ type: "Default" })) || []
  const meta_tags = (await getPageMetaTags(`/funds/${params.fcik}`, false)) || {}
  const { getMetaTags } = meta_tags || {}
  const { getBlogs: stock_ideas } = (await getStockIdeas()) || {}
  const posts = stock_ideas?.map((blog) => {
    const { data: frontmatter } = matter(blog?.content)
    return { slug: blog?.urlsuffix, frontmatter, }
  })
  const heat_tab_data = (await getFundTabs(params.fcik, "SUM_HEAT", preview)) || [];
  const { getFundTabs: _ } = heat_tab_data || {}
  let heatmap_settings = _ && _.length > 0 ? _.find(d => d.section_code === "heatmap") : null;
  return {
    props: {
      fund_info,
      fund_tabs,
      fund_news,
      chart_theme,
      page_info,
      fund_metrics,
      posts: posts?.sort(sortByDate) ?? [],
      stockideas_ads_settings: stock_ideas_ads || {},
      heatmapSettings: heatmap_settings || [],
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.ONE_MONTH,
    notFound: `${fund?.f}` === params.fcik ? false : true,
  }
}

export default withProtected(FCIK);
